import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { propTypes, reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Link } from 'react-router-dom';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import {
    MuiThemeProvider,
    createMuiTheme,
    withStyles,
} from '@material-ui/core/styles';
import LockIcon from '@material-ui/icons/Lock';

import { Notification, translate, userLogin, showNotification} from 'react-admin';
import queryString from 'query-string';

import { lightTheme } from './themes';

import { appNameText } from '../AppConfig'

const styles = theme => ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'flex-start',
        background: 'url(https://source.unsplash.com/random/1600x900)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
    card: {
        minWidth: 300,
        marginTop: '6em',
    },
    avatar: {
        margin: '1em',
        display: 'flex',
        justifyContent: 'center',
    },
    icon: {
        backgroundColor: theme.palette.secondary.main,
    },
    pktitle: {
        marginTop: '1em',
        display: 'flex',
        justifyContent: 'center'
    },
    hint: {
        marginTop: '1em',
        display: 'flex',
        justifyContent: 'center',
        color: theme.palette.grey[500],
    },
    form: {
        padding: '0 1em 1em 1em',
    },
    input: {
        marginTop: '1em',
    },
    actions: {
        padding: '0 1em 1em 1em',
    },
});

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({
    meta: { touched, error } = {},
    input: { ...inputProps },
    ...props
}) => {
    return <TextField
        error={!!(touched && error)}
        helperText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />
};



class ResetPassword extends Component {

  login = auth => {
    console.log('login function', auth)
      auth = {notif: this.props.showNotification, ...auth }
      this.props.userLogin(
          auth,
          this.props.location.state
              ? this.props.location.state.nextPathname
              : '/'
      );
  }
  render() {
    console.log('reset passwor')
    const { classes, handleSubmit, isLoading, translate } = this.props;
    return (
        <div className={classes.main}>
            <Card className={classes.card}>
                <h4 style={{textAlign: "center"}}>Reset Your Password</h4>
                <div className={classes.avatar}>
                    <Avatar className={classes.icon}>
                        <LockIcon />
                    </Avatar>
                </div>
                <form onSubmit={handleSubmit(this.login)} >
                    <div className={classes.pktitle}>{appNameText}</div>
                    <div className={classes.form}>
                        <div className={classes.input}>
                            <Field
                                autoFocus
                                name="username"
                                component={renderInput}
                                label={translate('ra.auth.username')}
                                disabled={isLoading}
                            />
                        </div>
                        <div className={classes.input}>
                            <Field
                                name="password"
                                component={renderInput}
                                label={translate('pk.new_password')}
                                type="password"
                                disabled={isLoading}
                            />
                        </div>
                        <div className={classes.input}>
                            <Field
                                name="confirm_password"
                                component={renderInput}
                                label={translate('pk.confirm_new_password')}
                                type="password"
                                disabled={isLoading}
                            />
                        </div>
                        <div className={classes.input}>
                            <Field
                                name="reset_token"
                                component={renderInput}
                                label={translate('Token')}
                                disabled={isLoading}
                                hidden={true}
                            />
                        </div>
                    </div>
                    <CardActions className={classes.actions}>
                        <Button
                            variant="raised"
                            type="submit"
                            color="primary"
                            disabled={isLoading}
                            className={classes.button}
                            fullWidth
                        >
                            {isLoading && (
                                <CircularProgress size={25} thickness={2} />
                            )}
                            {translate('pk.reset_password')}
                        </Button>
                    </CardActions>
                </form>
            </Card>
            <Notification />
        </div>
    )
  }
};



class Loginer extends Component {

      login = auth =>
          this.props.userLogin(
              auth,
              this.props.location.state
                  ? this.props.location.state.nextPathname
                  : '/'
          );
      render() {
          const { classes, handleSubmit, isLoading, translate } = this.props;
          console.log('props.location', this.props)
          const query_params = queryString.parse(this.props.location.search)
          return (
              <div className={classes.main}>
                  <Card className={classes.card}>
                      { query_params.previous === 'registration' ?
                          <h4 style={{textAlign: "center"}}>We've sent you an email! Open it up and verify your email to activate your account</h4> :
                          query_params.previous === 'request_password_reset' ?
                              <h4 style={{textAlign: "center"}}>We've sent you an email! Open it up and click the link to reset yor password</h4> :
                          query_params.token ? <h4 style={{textAlign: "center"}}>VERIFY REGISTRATION</h4> : <div />}
                      <div className={classes.avatar}>
                          <Avatar className={classes.icon}>
                              <LockIcon />
                          </Avatar>
                      </div>
                      <form onSubmit={handleSubmit(this.login)} >
                          <div className={classes.pktitle}>{appNameText}</div>
                          <div className={classes.form}>
                              <div className={classes.input}>
                                  <Field
                                      autoFocus
                                      name="username"
                                      component={renderInput}
                                      label={translate('ra.auth.username')}
                                      disabled={isLoading}
                                  />
                              </div>
                              {query_params.request_password_reset ? null : <div className={classes.input}>
                                  <Field
                                      name="password"
                                      component={renderInput}
                                      label={translate('ra.auth.password')}
                                      type="password"
                                      disabled={isLoading}
                                  />
                              </div>}
                              <div className={classes.input}>
                                  <Field
                                      name="token"
                                      component={renderInput}
                                      label={translate('Token')}
                                      disabled={isLoading}
                                      hidden={true}
                                  />
                              </div>
                          </div>
                          <CardActions className={classes.actions}>
                              <Button
                                  variant="raised"
                                  type="submit"
                                  color="primary"
                                  disabled={isLoading}
                                  className={classes.button}
                                  fullWidth
                              >
                                  {isLoading && (
                                      <CircularProgress size={25} thickness={2} />
                                  )}
                                  {query_params.request_password_reset ? translate('pk.request_password_reset') : translate('ra.auth.sign_in')}
                              </Button>
                          </CardActions>
                          <hr />
                          {query_params.request_password_reset ? null : <CardActions className={classes.actions}>
                              <Button
                                  variant="raised"
                                  color="primary"
                                  disabled={isLoading}
                                  className={classes.button}
                                  fullWidth
                              ><Link to={{pathname: "/register/create"}} >
                                  {isLoading && (
                                      <CircularProgress size={25} thickness={2} />
                                  )}
                                  {translate('pk.register')}
                                  </Link>
                              </Button>
                          </CardActions>}
                          {query_params.request_password_reset ? null : <CardActions className={classes.actions}>
                              <Button
                                  variant="raised"
                                  color="primary"
                                  disabled={isLoading}
                                  className={classes.button}
                                  fullWidth
                              >
                                <Link to={{
                                    pathname: "/request_password_reset/create"
                                 }}>
                                  {isLoading && (
                                      <CircularProgress size={25} thickness={2} />
                                  )}
                                  {translate('pk.i_forgot_my_password')}
                                  </Link>
                              </Button>
                          </CardActions>}
                      </form>
                  </Card>
                  <Notification />
              </div>
          );
      }
  }

class Login extends Component {
    render() {
        const query_params = queryString.parse(this.props.location.search)
        return (
            <div>
                {query_params.reset_password ? <ResetPassword {...this.props} /> : <Loginer {...this.props} /> }
                <Notification />
            </div>
        );
    }
}

Login.propTypes = {
    ...propTypes,
    authProvider: PropTypes.func,
    classes: PropTypes.object,
    previousRoute: PropTypes.string,
    translate: PropTypes.func.isRequired,
    userLogin: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
  const query_params = queryString.parse(props.location.search)
  return {
  isLoading: state.admin.loading > 0 ,
  initialValues: {
    token: query_params.request_password_reset ? 'request_password_reset' : query_params.token,
    reset_token: query_params.reset_token
  }
}};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        { userLogin, showNotification }
    ),
    reduxForm({
        enableReinitialize: true,
        form: 'signIn',
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;
            if (!values.username) {
                errors.username = translate('ra.validation.required');
            }
            if (!values.password) {
                errors.password = translate('ra.validation.required');
            }
            return errors;
        },
    }),
    withStyles(styles)
);

const EnhancedLogin = enhance(Login);

// We need to put the MuiThemeProvider decoration in another component
// Because otherwise the withStyles() HOC used in EnhancedLogin won't get
// the right theme
const LoginWithTheme = props => (
    <MuiThemeProvider theme={createMuiTheme(lightTheme)}>
        <EnhancedLogin {...props} />
    </MuiThemeProvider>
);

export default LoginWithTheme;
